import { api_ } from '@shared/plugIn/axios';

interface ConfirmTossPaymentParams {
  paymentKey: string;
  orderId: string;
  amount: number;
}

interface TossPaymentConfirmResponse {
  paymentKey: string;
  orderId: string;
  status: string;
  totalAmount: number;
  method: string;
  requestedAt: string;
  approvedAt: string;
}

export const confirmTossPayment = async (params: ConfirmTossPaymentParams) => {
  const { data } = await api_.post<TossPaymentConfirmResponse>(
    'public/shop-order/tosspayments/confirm',
    params,
  );
  return data;
};
